import React from 'react';
import {
  MasonryEngineNode,
  MasonryEngineNodeRendererProps,
} from '@leagueplatform/masonry-engine';
import {
  Card,
  HeadingText,
  StackLayout,
  Tag,
} from '@leagueplatform/genesis-core';
import type { GDSTagCategory } from '@leagueplatform/genesis-core';

export const formatClassNames = (...classNames: (string | undefined)[]) =>
  classNames?.filter(Boolean).join(' ') || '';

type HealthMetricRangeCardProps = {
  heading: string;
  label: string;
  category: GDSTagCategory;
};

type HealthMetricRangeCardNode = MasonryEngineNode<
  'healthMetricRangeCard',
  HealthMetricRangeCardProps
>;

export type HealthMetricRangeCardRendererProps =
  MasonryEngineNodeRendererProps<HealthMetricRangeCardNode>;

export function HealthMetricRangeCardRenderer({
  heading,
  label,
  category,
  locatorId,
  css,
  className,
  engineClassName,
  rootElementRef,
}: HealthMetricRangeCardRendererProps) {
  return (
    <Card.Elevated
      backgroundColor="primary"
      data-testid={locatorId}
      css={css}
      className={formatClassNames(engineClassName, className)}
      ref={rootElementRef}
    >
      <Card.Section padding="$one">
        <StackLayout
          orientation="horizontal"
          verticalAlignment="center"
          horizontalAlignment="spaceBetween"
          spacing="$one"
        >
          <HeadingText level="4" size="xs">
            {heading}
          </HeadingText>
          <Tag
            label={label}
            category={category}
            size="small"
            emphasis="subdued"
            css={{
              flex: 'none',
            }}
          />
        </StackLayout>
      </Card.Section>
    </Card.Elevated>
  );
}
